export const isDebugDiagnosticsEnabled = () => process.env.NODE_ENV !== "production";
